import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginInfoComponent} from './login-info';
import {LogoutComponent} from './logout/logout.component';
import {I18nModule} from '../i18n/i18n.module';

@NgModule({
  imports: [CommonModule, I18nModule],
  declarations: [LoginInfoComponent, LogoutComponent],
  exports: [LoginInfoComponent, LogoutComponent]
})
export class UserModule {}



// WEBPACK FOOTER //
// ./src/app/shared/user/user.module.ts